// extracted by mini-css-extract-plugin
export default {"Container":"About_Container__FxZMA","PageTitle":"About_PageTitle__3OpGX","ImgDiv":"About_ImgDiv__dFwW8","ProfileImage":"About_ProfileImage__QVfE9","Icon":"About_Icon__DNqod"};